export default "__VITE_ASSET__8c1d7eea__"